import React from 'react'
import { GatsbyImage } from 'gatsby-plugin-image'
import { PrismicRichText } from '@prismicio/react'

const Panel = ({ slice }) => {
  var panelColorClass = slice.slice_type + '-default'
  if (slice.primary.panel_color) {
    panelColorClass = slice.slice_type + '-' + slice.primary.panel_color.toLowerCase()
  }
  let grid = 'grid-cols-1 lg:grid-cols-2'
  if (slice.items.length === 3) {
    grid = 'lg:grid-cols-3'
  }

  return (
    <section className='component-panel mx-auto max-w-screen-xl p-4'>
      <div className={`relative ${panelColorClass} overflow-hidden rounded`}>
        {slice.primary.panel_main_icon.gatsbyImageData && (
          <div className='absolute top-0 right-0 m-2 h-12 w-12 sm:m-6 sm:h-20 sm:w-20'>
            <GatsbyImage image={slice.primary.panel_main_icon.gatsbyImageData} alt={slice.primary.panel_main_icon.alt || ''} />
          </div>
        )}
        {slice.primary.panel_title.text && (
          <div className='prose prose-lg max-w-none'>
            <h2 className='mt-0 pl-8 pt-8 pr-20'>{slice.primary.panel_title.text}</h2>
          </div>
        )}
        {slice.items && slice.items.length > 0 && (
          <div className={`grid ${grid} gap-4 p-8 pt-3`}>
            {slice.items.map((panelBody, index) => {
              return (
                <div className={`prose prose-lg max-w-none flex-auto${panelBody.panel_body.richText[0].type === 'image' ? ' col-span-full' : ''}`} key={`panel-${index}`}>
                  {panelBody.panel_body_title.text && <h3 className='lg:h-10'>{panelBody.panel_body_title.text}</h3>}
                  <PrismicRichText field={panelBody.panel_body.richText} />
                </div>
              )
            })}
          </div>
        )}
        {slice.primary.panel_footer.text && (
          <div className='panel-footer inset-x bottom-0 flex w-full flex-row content-center px-8 py-4 font-semibold'>
            {slice.primary.panel_footer_icon.gatsbyImageData && (
              <div className='mr-5 h-16 w-16'>
                <GatsbyImage image={slice.primary.panel_footer_icon.gatsbyImageData} alt={slice.primary.panel_footer_icon.alt || ''} />
              </div>
            )}
            <div className='prose prose-lg flex flex-col justify-center text-primary'>
              <PrismicRichText field={slice.primary.panel_footer.richText} />
            </div>
          </div>
        )}
      </div>
    </section>
  )
}

export default Panel
